import React from 'react';
import { usePermissionContext } from './context/PermissionContext.inner';

const Restricted = ({ children, to, fallback = null }) => {
  const { isAllowedTo } = usePermissionContext();
  return isAllowedTo(to) ? children : fallback;
};

export default Restricted;
